import { useMutation, useQueryClient } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { Topic } from '@pepper/utils/src/types/seo'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

type Parameters = {
  companyId: string
  projectId: string
  topicIds: string[]
}

const handleAddTopics = async ({
  companyId,
  projectId,
  topicIds,
}: Parameters): Promise<{
  status: 'error' | 'success'
  data?: Topic[]
  error?: string
}> => {
  try {
    const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/topics`
    const response = await axios.post(url, {
      project_id: projectId,
      suggested_topic_ids: topicIds,
    })

    return {
      status: 'success',
      data: response.data.data,
    }
  } catch (error) {
    return extract.error(error)
  }
}

export const useAddTopics = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: Parameters) => handleAddTopics(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['project-topics'])
      queryClient.invalidateQueries(['topic-suggestion'])
      queryClient.invalidateQueries(['project-domain-map'])
    },
  })
}
